'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.findDocumentSaga = findDocumentSaga;

var _effects = require('redux-saga/effects');

var _fileSaver = require('file-saver');

var _b64ToBlob = require('../../helpers/b64ToBlob');

var _b64ToBlob2 = _interopRequireDefault(_b64ToBlob);

var _selectSession = require('../../selectors/context/selectSession');

var _reduceOperation = require('../../actions/context/reduceOperation');

var _reduceOperation2 = _interopRequireDefault(_reduceOperation);

var _reduceLoading = require('../../actions/context/reduceLoading');

var _reduceLoading2 = _interopRequireDefault(_reduceLoading);

var _selectSubfolderPrefix = require('../../selectors/context/selectSubfolderPrefix');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/regeneratorRuntime.mark(findDocumentSaga);

function findDocumentSaga(action) {
	var session, subfolderPrefix, response, result;
	return regeneratorRuntime.wrap(function findDocumentSaga$(_context) {
		while (1) {
			switch (_context.prev = _context.next) {
				case 0:
					_context.next = 2;
					return (0, _effects.select)((0, _selectSession.selectSession)());

				case 2:
					session = _context.sent;
					_context.next = 5;
					return (0, _effects.select)((0, _selectSubfolderPrefix.selectSubfolderPrefix)());

				case 5:
					subfolderPrefix = _context.sent;
					_context.next = 8;
					return (0, _effects.call)(fetch, subfolderPrefix + '/api/document/find', {
						method: 'POST',
						credentials: 'same-origin',
						headers: {
							'Accept': 'application/json',
							'Authorization': session.authenticationToken.token,
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							document: {
								relatedEntity: action.payload.relatedEntity,
								templateCode: action.payload.templateCode
							}
						})
					});

				case 8:
					response = _context.sent;
					_context.next = 11;
					return (0, _effects.call)([response, 'json']);

				case 11:
					result = _context.sent;
					_context.next = 14;
					return (0, _effects.put)((0, _reduceOperation2.default)(result.operation));

				case 14:
					if (result.operation.status) {
						_context.next = 18;
						break;
					}

					_context.next = 17;
					return (0, _effects.put)((0, _reduceLoading2.default)(false));

				case 17:
					return _context.abrupt('return');

				case 18:
					(0, _fileSaver.saveAs)((0, _b64ToBlob2.default)(result.document.content, 'application/pdf'), result.document.fileName);
					_context.next = 21;
					return (0, _effects.put)((0, _reduceLoading2.default)(false));

				case 21:
				case 'end':
					return _context.stop();
			}
		}
	}, _marked, this);
}